var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRootFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 28,
    viewBox: "0 0 34 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "icon",
    d: "M13.6667 0.666748H3.66668C1.82501 0.666748 0.35001 2.15841 0.35001 4.00008L0.333344 24.0001C0.333344 25.8417 1.82501 27.3334 3.66668 27.3334H30.3333C32.175 27.3334 33.6667 25.8417 33.6667 24.0001V7.33341C33.6667 5.49175 32.175 4.00008 30.3333 4.00008H17L13.6667 0.666748Z",
    fill: "#516179"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9375 21.3999L19 21.3999C16.9583 21.3999 15.3542 19.7957 15.3542 17.7541L15.3542 12.6499L13.2396 14.7645C12.9479 15.0562 12.5104 15.0562 12.2187 14.7645C11.9271 14.4728 11.9271 14.0353 12.2187 13.7437L15.5729 10.3895C15.7187 10.2437 15.8646 10.1707 16.0833 10.1707C16.3021 10.1707 16.4479 10.2437 16.5937 10.3895L19.9479 13.7437C20.2396 14.0353 20.2396 14.4728 19.9479 14.7645C19.6562 15.0562 19.2188 15.0562 18.9271 14.7645L16.8125 12.6499L16.8125 17.7541C16.8125 18.9937 17.7604 19.9416 19 19.9416L22.9375 19.9416C23.375 19.9416 23.6667 20.2332 23.6667 20.6707C23.6667 21.1082 23.375 21.3999 22.9375 21.3999Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootFolder);
export default __webpack_public_path__ + "static/media/root-folder.02ce7dfe0f90f45e3ef823da9ca076c4.svg";
export { ForwardRef as ReactComponent };